import React from 'react'
import {ListGroup, Badge} from 'react-bootstrap'
import {RecipientFilters as FilterTypes, RecipientStats} from '../recipientsTypes'
import './RecipientFilters.css'

interface RecipientFiltersProps {
  filters: FilterTypes
  onFilterChange: (filters: Partial<FilterTypes>) => void
  stats?: RecipientStats
}

export const RecipientFilters: React.FC<RecipientFiltersProps> = ({
  filters,
  onFilterChange,
  stats = {total: 0, subscribed: 0, unsubscribed: 0},
}) => {
  return (
    <div className='recipient-filters'>
      <div className='filter-section'>
        <h6 className='filter-title'>Filters</h6>
        
        {/* Status Filter */}
        <ListGroup variant='flush' className='mb-4'>
          <ListGroup.Item
            action
            active={filters.status === 'ALL'}
            onClick={() => onFilterChange({status: 'ALL'})}
            className='d-flex justify-content-between align-items-center'
          >
            <div>
              <i className='bi bi-people me-2'></i>
              All Recipients
            </div>
            <Badge bg='secondary'>{stats.total}</Badge>
          </ListGroup.Item>
          
          <ListGroup.Item
            action
            active={filters.status === 'SUBSCRIBED'}
            onClick={() => onFilterChange({status: 'SUBSCRIBED'})}
            className='d-flex justify-content-between align-items-center'
          >
            <div>
              <i className='bi bi-check-circle me-2'></i>
              Subscribed
            </div>
            <Badge bg='success'>{stats.subscribed}</Badge>
          </ListGroup.Item>
          
          <ListGroup.Item
            action
            active={filters.status === 'UNSUBSCRIBED'}
            onClick={() => onFilterChange({status: 'UNSUBSCRIBED'})}
            className='d-flex justify-content-between align-items-center'
          >
            <div>
              <i className='bi bi-x-circle me-2'></i>
              Unsubscribed
            </div>
            <Badge bg='danger'>{stats.unsubscribed}</Badge>
          </ListGroup.Item>
        </ListGroup>

        {/* Tags Section (Placeholder) */}
        <div className='mb-4'>
          <h6 className='filter-subtitle'>Tags</h6>
          <p className='text-muted small'>
            <i className='bi bi-tags me-1'></i>
            Tag management coming in Sprint 2
          </p>
        </div>

        {/* Segments Section (Placeholder) */}
        <div className='mb-4'>
          <h6 className='filter-subtitle'>Segments</h6>
          <p className='text-muted small'>
            <i className='bi bi-grid me-1'></i>
            Segments coming in Sprint 3
          </p>
        </div>

        {/* Clear Filters */}
        {(filters.status !== 'ALL' || filters.search !== '') && (
          <div className='text-center'>
            <button
              className='btn btn-sm btn-outline-secondary'
              onClick={() => onFilterChange({status: 'ALL', search: '', tags: [], segment: ''})}
            >
              <i className='bi bi-x-circle me-1'></i>
              Clear Filters
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
